var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10H15.8333C14.9129 10 14.1667 10.7462 14.1667 11.6667V13.3333C14.1667 14.2538 14.9129 15 15.8333 15C16.7538 15 17.5 14.2538 17.5 13.3333V10ZM17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10M2.5 10V13.3333C2.5 14.2538 3.24619 15 4.16667 15C5.08714 15 5.83333 14.2538 5.83333 13.3333V11.6667C5.83333 10.7462 5.08714 10 4.16667 10H2.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6666V15C17.5 16.6666 16.9444 17.5 15.8333 17.5C14.7222 17.5 13.3333 17.5 11.6666 17.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.dcf8b8c21a69d07feb0d441add93bc78.svg";
export { ForwardRef as ReactComponent };